import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import { Prompt } from "react-router";

import { connect } from "react-redux";

import { Can } from "constants/abilityContext";
import { history, title, isChecked, validateProfileFields, displayErrorContext } from "utils";

import { Header, DocumentsList } from "components";
import { Icon, Input, notification, Button, Checkbox, Select, Spin } from "antd";

import { clientService, selectService } from "services";

// Composant de détails d'un modèle.
// Beaucoup d'optimisation possible (React Modeling 04h11 pour code optimisé et centralisé).
//
// Les fonctions suivantes sont implémentées :
// - formatTag()
//   Render le html approprié selon les clés données dans le html.
//   En read render du static, en edit ou create render des inputs.
// - handleChange()
//   Gère le changement d'une valeur.
// - handleSubmit()
//   Gère le submit du form, tant en edit qu'en create.
// - validateFields()
//   Valide les champs du form qui sont required, utilise la fonction validateProfileFields
//   de utils/form.
// - render()
//   Render commun pour les 3 modes, la gestion des inputs se fait dans
//   formatTag(), mais les conditions plus générales se font directement dans render()
class ClientPage extends Component {
  constructor(props) {
    super(props);

    const { id } = this.props.match.params;

    this.state = {
      client: {
        __type: "Client",
        id: id,
        status: 1,
        documents: [],
      },
      uploading: false,
      errors: {},
      edited: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateFields = this.validateFields.bind(this);
  }

  componentDidMount() {
    const { client } = this.state;
    const { edit, create } = this.props;

    this.doclist = React.createRef();

    if (!create) {
      clientService
        .get(client.id)
        .then((result) => {
          this.setState({ client: { ...client, ...result } });
        })
        .catch((e) => {
          history.push("/clients");
        });
    }
  }

  formatTag(key, fixed = false, label = "") {
    const { client, errors } = this.state;
    const { edit, create } = this.props;

    if ((!edit && !create) || (fixed && edit)) {
      switch (key) {
        default:
          return <b>{client[key]}</b>;
      }
    }

    var Tag = key === "text" ? Input.TextArea : Input;
    var input = (
      <Tag
        name={key}
        value={client[key]}
        autoSize={{ minRows: 3, maxRows: 20 }}
        onChange={(e) => this.handleChange(e.target.value, key)}
      />
    );

    var error = errors && errors[key];
    return <span className={error ? "error-wrap" : ""}>{input}</span>;
  }

  handleChange(value, key) {
    this.setState({
      client: { ...this.state.client, [key]: value },
      edited: true,
    });
  }

  handleSubmit() {
    if (!this.validateFields()) return;

    var client = { ...this.state.client };
    const { edit, create } = this.props;

    var func;

    if (edit) {
      func = clientService.update;
    } else if (create) {
      func = clientService.create;
    }

    delete client.documents;

    const errorNotif = (e) => {
      this.setState({ uploading: false });
      notification.open({
        message: "Une erreur s'est produite",
        description: "Veuillez réessayer ou contacter un administrateur.",
        placement: "bottomRight",
      });
    };

    this.setState({ uploading: true }, () => {
      func(client)
        .then((n) => {
          this.doclist.current
            .executeActions(n.id, "Client")
            .then(() => {
              notification.open({
                message: "Enregistrement effectué",
                description: "Vos changements ont été enregistrés avec succès.",
                placement: "bottomRight",
              });

              this.setState({
                client: { ...client, ...n },
                edited: false,
                uploading: false,
              });
              history.replace(`/clients/${n.id}`);
            })
            .catch((e) => errorNotif(e));
        })
        .catch((e) => errorNotif(e));
    });
  }

  validateFields() {
    const { client } = this.state;
    const { edit, create } = this.props;

    var fields = ["name"];
    var validation = validateProfileFields(client, fields);

    this.setState({ errors: validation.errors });
    return !validation.hasError;
  }

  render() {
    const { client, errors, uploading } = this.state;
    const { edit, create } = this.props;

    var mode = "read",
      pageTitle = "Détails d'un client",
      header = `Client #${client.id}`,
      bread = [{ to: "/clients", text: "Liste des clients" }, { text: client.id }];

    if (edit) {
      mode = "edit";
      pageTitle = "Édition d'un client";
      bread = [
        { to: "/clients", text: "Liste des clients" },
        { to: `/clients/${client.id}`, text: client.id },
        { text: "Édition" },
      ];
    } else if (create) {
      mode = "create";
      pageTitle = "Création d'un client";
      header = "Nouveau client";
      bread = [{ to: "/clients", text: "Liste des clients" }, { text: "Création" }];
    }

    return (
      <Fragment>
        <Helmet>{title(pageTitle)}</Helmet>

        <Header title={header} bread={bread} />

        <div className={`client-page main-content profile-content ${mode}`}>
          <Can do={mode} on={client}>
            <Spin
              indicator={<Icon type="loading" spin style={{ fontSize: "52px" }} />}
              spinning={uploading}
            >
              <ul className={"profile-main-content " + mode}>
                <li>
                  <label>Nom :</label>
                  {this.formatTag("name")}
                </li>

                <li>
                  <label>Adresse :</label>
                  {this.formatTag("address")}
                </li>

                <li>
                  <label>Code postal :</label>
                  {this.formatTag("zipcode")}
                </li>

                <li>
                  <label>Ville :</label>
                  {this.formatTag("city")}
                </li>

                <li>
                  <label>Téléphone :</label>
                  {this.formatTag("tel")}
                </li>

                <li>
                  <label>Nom du contact :</label>
                  {this.formatTag("contact_name")}
                </li>
              </ul>

              <DocumentsList
                ref={this.doclist}
                documents={client.documents}
                editable={edit || create}
                handleChange={this.handleChange}
              />

              {(edit || create) && (
                <Fragment>
                  {displayErrorContext(errors)}

                  <div className="buttons">
                    <Button type="link" onClick={() => history.goBack()}>
                      Annuler
                    </Button>
                    <Button
                      type="primary"
                      disabled={edit && !this.state.edited}
                      onClick={() => this.handleSubmit()}
                    >
                      {edit ? "Enregistrer les changements" : "Créer le client"}
                    </Button>
                  </div>

                  <Prompt
                    when={this.state.edited}
                    message="Attention, certaines de vos modifications n'ont pas été enregistrées. Voulez-vous vraiment quitter cette page ?"
                  />
                </Fragment>
              )}

              {!edit && !create && (
                <div className="buttons">
                  <Button
                    type="primary"
                    onClick={() => history.push("/clients/" + client.id + "/edit")}
                  >
                    Éditer ce client
                  </Button>
                </div>
              )}
            </Spin>
          </Can>
        </div>
      </Fragment>
    );
  }
}

export default ClientPage;
